// extracted by mini-css-extract-plugin
export default {"blocks":"AddProperty_blocks__qI0VR","add-property-block":"AddProperty_add-property-block__pn2Nj","column":"AddProperty_column__pmAhW"};